// The clinic's appointment surface.
//
// A modal rather than a route, matching every other AdminPage surface (see the
// Fax Inbox at AdminPage.js). AdminPage is already 21k lines; this feature
// adds one button and one mount there and keeps everything else out here.
//
// The staff-messaging project adds "Admins" and "Doctors" tabs here. They are
// deliberately ABSENT rather than disabled: a greyed-out tab reads as something
// broken or permission-gated, which is worse than not knowing it is coming.
import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";
import AvailabilityTab from "./AvailabilityTab";
import RequestsTab from "./RequestsTab";

export default function AppointmentInbox({ isOpen, onClose, schema }) {
  const [tabIndex, setTabIndex] = useState(0);
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Appointments — {schema}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {/* isLazy: opening the modal must not fire BOTH tabs' fetches. */}
          <Tabs index={tabIndex} onChange={setTabIndex} isLazy>
            <TabList>
              <Tab>Requests</Tab>
              <Tab>Availability</Tab>
            </TabList>
            <TabPanels>
              <TabPanel px={0}>
                <RequestsTab schema={schema} />
              </TabPanel>
              <TabPanel px={0}>
                <AvailabilityTab schema={schema} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
